const MODAL_PROMO = {
	eyebrow: 'Welcome bonus',
	headline: '200%',
	subheadline: 'up to $1000',
}

export function AuthModalPromo() {
	return (
		<div className='relative hidden min-h-0 w-[340px] flex-[0.9] shrink-0 self-stretch rounded-xl rounded-l-2xl lg:flex lg:h-auto lg:flex-col'>
			<img src='/images/auth/promo-bg.png' alt='' className='absolute inset-0 h-full w-full rounded-xl object-cover object-center' aria-hidden />
			<div className='relative z-10 flex min-h-0 flex-1 flex-col'>
				<img src='/images/auth/logo.png' alt='Bets cycle' className='relative mx-auto mt-6 h-7 w-auto shrink-0 object-contain px-8 sm:mt-8 sm:h-8 lg:mt-10' />
				<div className='flex min-h-0 flex-1 items-center justify-center px-2 py-2'>
					<img src='/images/auth/becy-modal.png' alt='' className='h-full max-h-full w-full max-w-[600px] object-contain object-center' aria-hidden />
				</div>
				<div className='relative -top-5 shrink-0 space-y-1 px-8 pb-4 italic sm:px-10'>
					<p className='pb-2 text-lg font-medium tracking-[-0.24px] text-foreground/90 sm:pb-4 sm:text-xl'>{MODAL_PROMO.eyebrow}</p>
					<p className='pb-1 text-4xl font-extrabold leading-none tracking-[-0.6px] text-foreground sm:text-5xl'>{MODAL_PROMO.headline}</p>
					<p className='text-4xl font-bold tracking-[-0.36px] text-foreground sm:text-5xl'>{MODAL_PROMO.subheadline}</p>
				</div>
			</div>
			<div className='flex shrink-0 justify-center'>
				<span className='block h-1 w-16 rounded-full bg-white shadow-[0_0_10px_2px_hsl(var(--primary)/0.4),0_0_12px_2px_hsl(var(--primary)/0.2)]' aria-hidden />
			</div>
		</div>
	)
}
